module.exports = __webpack_public_path__ + "static/media/wines-direct.3c3efacd.JPG";